export const shouldApplyBalanceUpdate = (
  incomingHeight: number | undefined,
  currentHeight: number | undefined,
  incomingGameAccountUpdated: number,
  currentGameAccountUpdated: number | undefined
) => {
  if (incomingGameAccountUpdated > (currentGameAccountUpdated ?? 0)) {
    return true
  }

  if (currentHeight === undefined) {
    return true
  }

  return (incomingHeight ?? 0) >= currentHeight
}
